import { render, staticRenderFns } from "./download-staff.vue?vue&type=template&id=373bd196&"
import script from "./download-staff.vue?vue&type=script&lang=js&"
export * from "./download-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports